import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from "./citizens-services-requirements.graphql";
import * as fromActions from "./citizens-services-requirements.actions";
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';

@Injectable()
export class CitizensServicesRequirementsEffects {


  citizenGetServicesRequirements$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetServicesRequirements),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CITIZEN_SERVICES_REQUIREMENT,
        fetchPolicy: 'network-only',
        variables:{
          serviceUniqueId:action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any =  data?.citizenGetServicesRequirements
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensServicesRequirementss({ citizensServicesRequirementss: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
